import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function KBHome() {
  const { currentUser } = useAuth();
  const userGroups = currentUser?.['cognito:groups'] || [];
  const isAdminUser = userGroups.includes('oscar_admin_user');

  if (!isAdminUser) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        color: '#721c24',
        backgroundColor: '#f8d7da',
        border: '1px solid #f5c6cb',
        borderRadius: '4px',
        margin: '20px'
      }}>
        Unauthorized: This page is only accessible to admin users.
      </div>
    );
  }

  return (
    <div className="kb-container">
      <main className="kb-main">
        <div className="kb-search">
          <input 
            type="text" 
            placeholder="Search knowledge base..."
            className="search-input"
          />
        </div>

        <div className="kb-content">
          <section className="kb-categories">
            <h2>Categories</h2>
            <ul>
              <li>Getting Started</li>
              <li>Installation & Setup</li>
              <li>Configuration</li>
              <li>Troubleshooting</li>
              <li>Best Practices</li>
            </ul>
          </section>

          <section className="kb-recent">
            <h2>Recent Articles</h2>
            <div className="articles-grid">
              <div className="article-card">
                <h3>Getting Started with OpenSearch</h3>
                <p>Learn the basics of OpenSearch and how to set up your first cluster.</p>
              </div>
              <div className="article-card">
                <h3>Security Best Practices</h3>
                <p>Essential security configurations and best practices for OpenSearch.</p>
              </div>
              <div className="article-card">
                <h3>Performance Tuning</h3>
                <p>Optimize your OpenSearch cluster for better performance.</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
